import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import event from '~helpers/mixpanel';
import CounterOffer from '~components/counter-offer';
import { decodeBase64 } from 'common/helpers/decodeBase64';
import { pageType } from '~constants/pages';

export default class AcceptModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    if (this.props.isAutoOpen) {
      this.setState({ visible: true });
    }
  }

  acceptModalContent = () => {
    const { t, record } = this.props;

    return (
      <>
        <span>{t('landlord.payment.long_tail.accept_booking.modal.desc')}</span>
        <CounterOffer property={record} t={t} />
      </>
    );
  };

  handleShowAcceptModal = () => {
    const { property, referenceId, bookingJourney, stage } = this.props.record || {};
    const { name, id, slug } = property || {};
    const decodedId = decodeBase64(id)?.id;
    const eventProperties = {
      'Clicked Position': 'Accept',
      'Property Name': name,
      'Property ID': decodedId,
      'Property Slug': slug,
      'Booking Stage': stage?.toLowerCase(),
      'Booking Journey': bookingJourney?.toLowerCase(),
      'Booking ID': referenceId,
    };

    if (this.props.history.location?.pathname === '/board') {
      eventProperties['Current Page Type'] = pageType.dashboard;
      event('Clicked Pending Information Btn', eventProperties);
    }
    if (this.props.history.location.pathname?.includes('/detail')) {
      this.props?.handleClickActionBtnTrack?.('Accept');
    }
    if (this.props.history.location?.pathname === '/booking/list') {
      eventProperties['Current Page Type'] = pageType.bookingList;
      event('Clicked Action Btn in Booking List Page', eventProperties);
    }

    this.setState({
      visible: !this.state.visible,
    });
  };
  cancelModal = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };
  render() {
    const { type, id, t, confirmOrder, confirmLoading } = this.props;
    const { visible } = this.state;
    return (
      <div className="accept-modal">
        <Choose>
          <When condition={type === 'list'}>
            <button className="accept-modal__btn" onClick={this.handleShowAcceptModal}>
              {t('landlord.long_tail.booking.action.accept')}
            </button>
          </When>
          <Otherwise>
            <Button onClick={this.handleShowAcceptModal} className="accept-modal__btn--detail">
              <CheckOutlined />
              {t('landlord.long_tail.booking_details.btn.accept')}
            </Button>
          </Otherwise>
        </Choose>
        <Modal
          title={t('landlord.payment.long_tail.accept_booking.modal.title')}
          width={812}
          visible={visible}
          okText={t('landlord.payment.long_tail.button.accept')}
          okButtonProps={{
            loading: confirmLoading,
            disabled: confirmLoading,
          }}
          onOk={() => {
            confirmOrder(id);
            this.handleShowAcceptModal();
          }}
          cancelText={t('landlord.payment.long_tail.button.cancel')}
          onCancel={this.cancelModal}
          wrapClassName="accept-modal__wrapper"
        >
          {this.acceptModalContent()}
        </Modal>
      </div>
    );
  }
}

AcceptModal.propTypes = {
  t: PropTypes.func,
  id: PropTypes.string,
  type: PropTypes.string,
  confirmOrder: PropTypes.func,
  isAutoOpen: PropTypes.bool,
  record: PropTypes.object,
  confirmLoading: PropTypes.bool,
  handleClickActionBtnTrack: PropTypes.func,
  fromPage: PropTypes.string,
};

AcceptModal.defaultProps = {
  t: () => {},
  id: '',
  type: '',
  confirmOrder: () => {},
  isAutoOpen: false,
  record: {},
  confirmLoading: false,
};
